const HiddenMenu = new function() {
    const elSelector = '.na-hidden-menu'
    const menuButtonsSelector = '.na-menu-button'
    const menuLinksSelector = '.na-hidden-menu a:not([target="_blank"]):not([href^="#"])'

    this.el = null
    this.menuButtons = []
    this.menuLinks = []
    
    let isOpen = false

    this.init = () => {
        this.el = document.querySelector(elSelector)
        this.setTriggers()
    }

    this.setTriggers = () => {
        this.menuButtons = []
        this.menuLinks = []
        document.querySelectorAll(menuButtonsSelector).forEach(button => this.menuButtons.push(button))
        document.querySelectorAll(menuLinksSelector).forEach(link => this.menuLinks.push(link))
        this.menuButtons.forEach(button => button.addEventListener('click', this.toggleMenu))
        this.menuLinks.forEach(link => link.addEventListener('click', this.closeMenu))
        
    }

    this.toggleMenu = () => {
        isOpen ? this.closeMenu() : this.openMenu()
    }

    this.openMenu = () => {
        this.el.classList.add('open')
        isOpen = true
    }
    
    this.closeMenu = () => {
        this.el.classList.remove('open')
        isOpen = false
    }

    this.update = () => {
        this.el = document.querySelector(elSelector)
        this.menuButtons.forEach(button => button.removeEventListener('click', this.toggleMenu))
        this.menuLinks.forEach(link => link.removeEventListener('click', this.closeMenu))
        this.setTriggers()
    }
}

export default HiddenMenu